
import {
  computed,
  defineComponent,
  PropType,
  ref,
} from 'vue';
import draggable from 'vuedraggable';
import StatsBuilderRow from '@/components/stats-builder/StatsBuilderRow.vue';
import { StatsBuilderRowConfig } from '@/types/stats-editor-types';
import { StatsEditorPanelEnum } from '@/types';
import Tooltip from 'primevue/tooltip';
import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';

export default defineComponent({
  name: 'StatsBuilder',

  components: {
    StatsBuilderRow,
    draggable,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    pageRowsState: {
      type: Array as PropType<StatsBuilderRowConfig[]>,
      required: true,
    },
  },

  setup(props: { pageRowsState: StatsBuilderRowConfig[] }) {
    const { t } = useI18n();
    const store = useStore();
    const enabled = ref(true);
    const dragging = ref(false);
    const dragOptions = ref({
      animation: 200,
      group: { name: 'line_builder', pull: false, put: ['line_element', 'widget_element'] },
      disabled: false,
      onStart: () => {
        store.commit('statsEditor/setIsDraggingBuilderItem', true);
      },
      onEnd: () => {
        store.commit('statsEditor/setIsDraggingBuilderItem', false);
      },
    });

    const isEmpty = computed(() => props.pageRowsState.length === 0);

    const openElementsPanel = () => {
      store.commit('statsEditor/showLeftToolbar', StatsEditorPanelEnum.ELEMENTS_LIST_PANEL);
    };

    return {
      t,
      enabled,
      dragging,
      dragOptions,
      isEmpty,
      openElementsPanel,
    };
  },
});
